// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"466":"0d66c079","636":"22c32c65","787":"c6ecf9b8"}[chunkId] + ".chunk.js";
};